export default __webpack_public_path__ + "static/assay-5e418634cda467794eb6a47f329ec253.png";